import React from 'react'
import { XCircleIcon } from '@heroicons/react/24/solid'
import EtCreateUserReflectionComp from '@/features/userReflections/EtCreateUserReflectionComp'

const EtModalCreateUserReflection = ({ 
    userId = null,
    userOrgId = null,
    showModal = false, 
    onClose = () => {}, 
    refetchUserReflectionsAll = () => {},
    refetchUserReflections = null,   // FUTURE USE
    defaultTrailId = '', 
    defaultSessionId = '' ,

    // 31 Aug 2026
    canSyncGoogleDoc = false,

}) => {

    // First Created -  04 Dec 2025  
    // Author  - Atul Pandey  
    // Purpose -  Modal wrapper for creating a user reflection
    // Updated - 05 Dec 2025 - Refined props
    // Updated - 31 Aug 2026 - added canSyncGoogleDoc 
    
  
    if (!showModal) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-start font-poppins overflow-y-auto p-4" style={{ zIndex: 9999 }}>
      <div className="bg-black p-3 rounded-lg shadow-lg shadow-black relative w-full max-w-5xl">
        
        {/* Close Button */}
        <div
            className="absolute top-1 right-1 m-1 font-bold rounded-full cursor-pointer h-7 w-7 flex justify-center items-center"
            onClick={onClose}
        >
            <XCircleIcon className='text-orange-600 rounded-full hover:text-red-600 h-7 w-7' />
        </div>

        {/* Create Form Component */}
        <EtCreateUserReflectionComp 
          userId={userId}
          userOrgId={userOrgId}  
          onClose={onClose} 
          refetchUserReflections={refetchUserReflections} 
          refetchUserReflectionsAll={refetchUserReflectionsAll} 
          defaultTrailId={defaultTrailId}         
          defaultSessionId={defaultSessionId}  
          
          // 31 Aug 2026
          canSyncGoogleDoc={canSyncGoogleDoc}
        />

      </div>
    </div>
  )
}

export default EtModalCreateUserReflection
